/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Search, breakpoints, useMediaQuery } from '@coursera/cds-core';

type Props = {
  placeholder: string;
  value: string;
  id?: string;
  dataTestId?: string;
  onBlur?: () => void;
  onFocus?: () => void;
  onChange: (value: string) => void;
  onClear?: () => void;
  ref?: React.RefObject<HTMLInputElement>;
  disabled?: boolean;
  autoComplete?: string;
  ariaLabel?: string;
  shouldShowOnboardingV3?: boolean;
};

const styles = {
  compactSearchContainer: css`
    align-self: flex-start;

    svg {
      width: 20px;
      height: 20px;
      color: var(--cds-color-neutral-primary-weak);
    }

    .cds-input-root {
      border-radius: 100px;
      width: 290px;

      ${breakpoints.down('xs')} {
        width: 100%;
      }
    }

    .cds-input-input {
      padding-left: var(--cds-spacing-100) !important;
    }
  `,
  searchContainer: css`
    width: 600px;
    margin: 0 auto;
    ${breakpoints.down('xs')} {
      width: 100%;
    }

    svg {
      width: 20px;
      height: 20px;
      color: var(--cds-color-interactive-primary);
    }

    .cds-input-root {
      border-radius: 100px;
    }
  `,
};

const OnboardingSearch = ({ ariaLabel, dataTestId, shouldShowOnboardingV3, ...props }: Props) => {
  const isMobile = useMediaQuery(breakpoints.down('xs'));

  return (
    <Search
      {...props}
      css={shouldShowOnboardingV3 ? styles.compactSearchContainer : styles.searchContainer}
      hideSearchButton
      onSearch={() => {}}
      fullWidth={!shouldShowOnboardingV3 || isMobile}
      aria-label={ariaLabel}
      data-testid={dataTestId}
    />
  );
};

export default OnboardingSearch;
